'use strict';

angular.module('myConsultApp').directive('sideNav', function ($location) {
  return {
    templateUrl: 'templates/v2/side-nav.html',
    restrict: 'A',
    link: function (scope, elem, attr) {
      angular.element(document).ready(function () {
        scope.isMinimized = true;
        scope.toSnakeCase = function (s) {
          if (typeof s !== 'string') {
            return s;
          }
          const words = s.split(' ');
          return words
            .map(function (word) {
              return word.toLowerCase();
            })
            .join('-');
        };
        scope.hideCollapse = function (parent) {
          parent.find('.accordion').attr('aria-expanded', 'false');
          parent.find('.collapse.in').collapse('hide');
        };
        scope.logout = function () {
          if (scope.isMinimized == true) {
            $('.left-side-nav').removeClass('minimized');
            scope.isMinimized = false;
          } else {
            $location.path('/logout');
          }
        };

        $('.collapse').on('hidden.bs.collapse', function (e) {
          e.stopPropagation();
          scope.hideCollapse($(this));
        });

        $('.left-side-caption').on('click', function () {
          if (scope.isMinimized === true) {
            $('.left-side-nav').removeClass('minimized');
          } else {
            $('.left-side-nav').addClass('minimized');
          }
          scope.hideCollapse($('.left-side-nav'));
          scope.$apply(function () {
            scope.isMinimized = !scope.isMinimized;
          });
        });

        $(document).on('click', function (e) {
          var $target = $(e.target);
          if (!$target.closest('.left-side-nav').length && !scope.isMinimized) {
            $('.left-side-nav').addClass('minimized');
            scope.hideCollapse($('.left-side-nav'));
            scope.$apply(function () {
              scope.isMinimized = !scope.isMinimized;
            });
          }
        });

        $('a.left-side-content').on('click', function () {
          $('.left-side-nav').addClass('minimized');
          scope.$apply(function () {
            scope.isMinimized = true;
            scope.hideCollapse($('.left-side-nav'));
          });
        });

        $('.action-icon').on('click', function () {
          var alt = $(this).attr('data-id');
          if (alt == 'dashboard') {
            $location.path('/admin');
          } else {
            $('.left-side-nav').removeClass('minimized');
            var id = scope.toSnakeCase(alt);

            $('#' + id)
              .prev()
              .attr('aria-expanded', 'true');
            $('#' + id).collapse('show');

            scope.$apply(function () {
              scope.isMinimized = false;
            });
          }
        });
      });
    },
  };
});
